/* import __COLOCATED_TEMPLATE__ from './header.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
import type { ComponentLike, ContentValue } from '@glint/template';

import type { BvBtnArgs } from '../bv-btn';

interface IAction extends BvBtnArgs {
  visible?: boolean;
  classNames?: string;
}

export interface BvCardHeaderSignature {
  Args: {
    actions?: IAction[];
    subtitle?: ContentValue | ComponentLike;
    title?: ContentValue | ComponentLike;
  };
  Blocks: {
    default: [];
  };
  Element: HTMLDivElement;
}

const BvCardHeaderComponent = templateOnlyComponent<BvCardHeaderSignature>();

export default BvCardHeaderComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'BvCard::Header': typeof BvCardHeaderComponent;
    'bv-card/header': typeof BvCardHeaderComponent;
  }
}
